<template>
  <div v-if="$store.state.hasData === false" >
    <base-spinner></base-spinner>
  </div>
  <div v-else :style="{ backgroundColor: backgroundColor }">
    <button @click="scrollToTop" class="scroll-to-top-btn"
      v-if="!$route.path.startsWith('/management-details') && $route.path !== '/login'">
      <i class="fa-solid fa-up-long"></i>
    </button>
    <button @click="toMess" class="to-mess-btn"
      v-if="!$route.path.startsWith('/management-details') && $route.path !== '/login'">
      <i class="fa-brands fa-facebook-messenger"></i>
    </button>

    <div class="call-container" v-if="$route.path.startsWith('/training-services')">
      <button @click="toCallTS" class="to-call-btn"
        v-if="!$route.path.startsWith('/management-details') && $route.path !== '/login'">
        <i class="fa-solid fa-phone"></i>
        <div class="home-tooltip">
          <img src="../src/assets/plane-icon.png" style="margin-right: 5px; width: 25px; height: 25px;">
          <span class="home-tel">+84 819 168 855</span>
        </div>
      </button>
    </div>
    <div class="call-container" v-else-if="$route.path.startsWith('/admissions')">
      <button @click="toCallAdmission" class="to-call-btn"
        v-if="!$route.path.startsWith('/management-details') && $route.path !== '/login'">
        <i class="fa-solid fa-phone"></i>
        <div class="home-tooltip">
          <img src="../src/assets/plane-icon.png" style="margin-right: 5px; width: 25px; height: 25px;">
          <span class="home-tel">+84 906 787 350</span>
        </div>
      </button>
    </div>
    <div class="call-container" v-else>
      <button @click="toCall" class="to-call-btn"
        v-if="!$route.path.startsWith('/management-details') && $route.path !== '/login'">
        <i class="fa-solid fa-phone"></i>
        <div class="home-tooltip">
          <img src="../src/assets/plane-icon.png" style="margin-right: 5px; width: 25px; height: 25px;">
          <span class="home-tel">{{ getPhoneNumber }}</span>
        </div>
      </button>
    </div>

      <button @click="toZalo" class="to-zalo-btn"
      v-if="!$route.path.startsWith('/management-details') && $route.path !== '/login'">
      <img @contextmenu.prevent src="../src/assets/zalo-icon.svg">
    </button>

    <!-- <button @click="toMess" class="to-viber-btn"
      v-if="!$route.path.startsWith('/management-details') && $route.path !== '/login'">
      <i class="fa-brands fa-viber"></i>
    </button>  -->
    <RouterView></RouterView>
  </div>
</template>

<script>
export default {
  computed: {
    backgroundColor () {
      return this.$store.getters['color/backendBgColor'][0].hexValue
    },
    getPhoneNumber () {
      return this.$store.getters['contact/getPhoneNumber']
    }
  },
  methods: {
    scrollToTop () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth' // Enables smooth scrolling
      })
    },

    toViper () {
      // window.open('viber://chat?number=84529123956', '_blank')
      const viberLink = `viber://chat?number=${this.getPhoneNumber}`
      const fallbackLink = 'https://www.viber.com/download/'

      const newWindow = window.open(viberLink, '_blank')

      // If the popup is blocked or Viber isn't installed, redirect to the fallback page
      setTimeout(() => {
        if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
          window.location.href = fallbackLink
        }
      }, 1000)
    },
    toMess () {
      window.open('https://m.me/FlightTrainingCenter.VNA/', '_blank')
    },
    toZalo () {
      window.open('https://zalo.me/+84906787350', '_blank')
    },
    toCall () {
      window.location.href = `tel:${this.getPhoneNumber}`
    },
    toCallTS () {
      window.location.href = 'tel: +84 819 168 855'
    },
    toCallAdmission () {
      window.location.href = 'tel: +84 906 787 350'
    }
  }
}
</script>

<style>
/* @import  url('https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap'); */

@font-face{
  /* font-family: 'Inter';
    src: url('https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap') format('woff2'); */
  font-family: 'Diavlo Book';
    src: url('@/assets/fonts/Diavlo_BOOK_II_37 Jos.otf') format('opentype');

}
@font-face{
  /* font-family: 'Inter';
    src: url('https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap') format('woff2'); */
  font-family: 'Archivo';
    src: url('@/assets/fonts/Archivo-VariableFont_wdth,wght.ttf') format('opentype');

}
@font-face{
  /* font-family: 'Inter';
    src: url('https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap') format('woff2'); */
  font-family: 'Open Sans';
    src: url('@/assets/fonts/OpenSans-Regular.ttf') format('opentype');

}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  scroll-behavior: smooth;
  /* font-family: Arial, Helvetica, sans-serif; */
  font-family: "Open Sans";
  font-optical-sizing: auto;
  /* font-weight: 400;
  font-style: normal; */
}

.scroll-to-top-btn {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 40px;
  height: 40px;
  background-color: hsla(0, 1%, 70%, 0.473);
  color: #006884;
  border: none;
  border-radius: 50%; /* Makes the button circular */
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s;
  z-index: 100;
}

.to-viber-btn {
  position: fixed;
  bottom: 170px;
  right: 20px;
  width: 40px;
  height: 40px;
  background-color: hsla(0, 1%, 70%, 0.473);
  color: #006884;
  border: none;
  border-radius: 50%; /* Makes the button circular */
  cursor: pointer;
  font-size: 17px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s;
  z-index: 100;
}

.to-zalo-btn {
  position: fixed;
  bottom: 120px;
  right: 20px;
  width: 40px;
  height: 40px;
  background-color: hsla(0, 1%, 70%, 0.473);
  color: #006884;
  border: none;
  border-radius: 50%; /* Makes the button circular */
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s;
  z-index: 100;
}

.to-mess-btn {
  position: fixed;
  bottom: 70px;
  right: 20px;
  width: 40px;
  height: 40px;
  background-color: hsla(0, 1%, 70%, 0.473);
  color: #006884;
  border: none;
  border-radius: 50%; /* Makes the button circular */
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s;
  z-index: 100;
}

.to-call-btn {
  position: fixed;
  bottom: 170px;
  right: 20px;
  width: 40px;
  height: 40px;
  background-color: hsla(0, 1%, 70%, 0.473);
  color: #006884;
  border: none;
  border-radius: 50%; /* Makes the button circular */
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s;
  z-index: 100;
}

.scroll-to-top-btn:hover,
.to-mess-btn:hover,
.to-call-btn:hover,
.to-zalo-btn:hover,
.to-viber-btn:hover {
  background-color: hsla(0, 0%, 81%, 0.42);
}

.home-tooltip {
  position: absolute;
  left: -150px;
  top: 50%;
  transform: translateY(-50%);
  color: #fff;
  background: #006884;
  padding: 8px 12px;
  border-radius: 4px;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
}

.call-container:hover .home-tooltip {
  opacity: 1;
  visibility: visible;
  left: -200px; /* Moves further left when hovered */
}

/* @media (min-width: 1135px) {
  .to-call-btn {
    display: none;
  }

  .call-container {
    display: none;
  }
} */
</style>
